import script from "./extinguisherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./extinguisherForm.vue?vue&type=script&setup=true&lang=js"

import "./extinguisherForm.vue?vue&type=style&index=0&id=327fc435&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327fc435"]])

export default __exports__